(() => {
  const theme = window.BeaniesTheme || {};
  const routes = theme.routes || {};
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const money = new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: theme.currency || 'AUD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });

  const drawer = document.querySelector('[data-cart-drawer]');
  const scrim = document.querySelector('.cart-scrim');
  const lines = document.querySelector('.cart-lines');
  const empty = document.querySelector('.empty-cart');
  const options = document.querySelector('.cart-options');
  const zone = document.querySelector('#delivery-zone');
  const notes = document.querySelector('#order-notes');
  const checkout = document.querySelector('.checkout-button');
  const toast = document.querySelector('.toast');
  let cartState = null;
  let attributesTimer;

  const escapeHTML = value => String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  function showToast(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    clearTimeout(showToast.timer);
    showToast.timer = setTimeout(() => toast.classList.remove('show'), 2200);
  }

  function setCount(count) {
    document.querySelectorAll('.cart-count').forEach(element => {
      element.textContent = count;
      element.setAttribute('aria-label', `${count} item${count === 1 ? '' : 's'}`);
    });
    document.querySelectorAll('.mobile-order-count').forEach(element => {
      element.textContent = `${count} item${count === 1 ? '' : 's'}`;
    });
  }

  const bedProductIds = new Set([15225867600045, 15225870155949]);
  const hasBed = cart => cart?.items?.some(item => bedProductIds.has(Number(item.product_id)));
  const planterOnly = cart => cart?.items?.length > 0 && !hasBed(cart) && cart.items.every(item => Number(item.product_id) === 15225877594285);

  const cafeProductIds = new Set([15361824129197, 15361834090669]);
  const isCafeItem = item => cafeProductIds.has(Number(item.product_id));
  const hasCafe = cart => cart?.items?.some(isCafeItem);
  const cafeOnly = cart => cart?.items?.length > 0 && cart.items.every(isCafeItem);
  const cafeWeekendOpen = () => Date.now() < Date.parse('2026-11-09T00:00:00+10:00');
  const normalZoneOptions = zone?.innerHTML || '';
  function configureDeliveryOptions(cart) {
    if (!zone) return;
    const cafe = hasCafe(cart);
    const mode = cafe ? 'cafe' : 'normal';
    if (zone.dataset.mode !== mode) {
      zone.innerHTML = cafe ? '<option value="Vintage Cow Café pickup">Vintage Cow Café pickup — 7–8 November</option><option value="Vintage Cow Café delivery">Café delivery within 30 km</option><option value="Vintage Cow Café quote">Café delivery over 30 km — quote</option>' : normalZoneOptions;
      zone.dataset.mode = mode;
    }
  }
  function canCheckout() {
    if (hasCafe(cartState)) return cafeOnly(cartState) && cafeWeekendOpen() && ['Vintage Cow Café pickup', 'Vintage Cow Café delivery'].includes(zone?.value);
    return hasBed(cartState) && (!zone || zone.value === 'Toowoomba and surrounds');
  }
  function deliveryCopy() {
    if (hasCafe(cartState)) {
      if (!cafeWeekendOpen()) return 'The 7–8 November café weekend has ended. Contact us for current availability.';
      if (!cafeOnly(cartState)) return 'Please order café beds separately from the regular range so the correct delivery or pickup options apply.';
      if (zone?.value === 'Vintage Cow Café pickup') return 'Free pickup on 7–8 November from Vintage Cow Café, 105 Mocatta Street, Goombungee. Choose Pickup at checkout and wait for your ready-to-collect confirmation.';
      if (zone?.value === 'Vintage Cow Café quote') return 'Over 30 km from Vintage Cow Café: contact us for a delivery quote before payment.';
      return 'From Vintage Cow Café: up to 15 km $20; over 15–30 km $60. Enter your address and choose delivery at checkout. Over 30 km requires a quote.';
    }
    if (planterOnly(cartState)) return 'Planters on their own are market pickup only, or can be delivered with a bed.';
    if (zone?.value === 'Market pickup') return 'Contact us to arrange your pickup market and date.';
    if (zone && zone.value !== 'Toowoomba and surrounds') return 'Beyond 50 km, request a delivery quote before payment.';
    return 'Delivery within 50 km. Your address sets the delivery charge at checkout.';
  }
  function updateCheckout() {
    if (checkout) checkout.textContent = canCheckout() ? 'Checkout' : (planterOnly(cartState) || zone?.value === 'Market pickup' ? 'Arrange market pickup' : 'Request a delivery quote');
    if (checkout && hasCafe(cartState) && !cafeOnly(cartState)) checkout.textContent = 'Order café beds separately';
    const message = document.querySelector('.delivery-message');
    if (message) message.textContent = deliveryCopy();
    const paymentNote = document.querySelector('.no-payment');
    if (paymentNote) paymentNote.textContent = canCheckout() ? 'You’ll see the delivery charge before you pay.' : 'We’ll confirm your quote or pickup arrangements, then send a payment link.';
  }

  function renderCart(cart) {
    cartState = cart;
    if (!drawer || !lines || !empty || !options) return;
    setCount(cart.item_count);
    const total = document.querySelector('.cart-total strong');
    const deliveryMessage = document.querySelector('.delivery-message');
    if (total) total.textContent = money.format(cart.total_price / 100);
    if (deliveryMessage) deliveryMessage.textContent = deliveryCopy();

    empty.classList.toggle('hidden', cart.item_count > 0);
    options.classList.toggle('hidden', cart.item_count === 0);
    if (checkout) {
      checkout.classList.toggle('is-disabled', cart.item_count === 0);
      checkout.setAttribute('aria-disabled', cart.item_count === 0 ? 'true' : 'false');
      checkout.tabIndex = cart.item_count === 0 ? -1 : 0;
    }

    lines.innerHTML = cart.items.map(item => {
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<span>${escapeHTML(item.variant_title)}</span>` : '';
      const image = item.image ? `<img class="cart-line-image" src="${escapeHTML(item.image)}" alt="" width="70" height="70">` : '';
      return `<div class="cart-line" data-line-key="${escapeHTML(item.key)}">
        ${image}
        <div class="cart-line-copy"><p class="cart-line-title">${escapeHTML(item.product_title)}</p>${variant}<span class="cart-line-price">${money.format(item.final_price / 100)} each</span></div>
        <div class="line-controls"><button type="button" data-action="decrease" aria-label="Decrease ${escapeHTML(item.product_title)}">−</button><span>${item.quantity}</span><button type="button" data-action="increase" aria-label="Increase ${escapeHTML(item.product_title)}">+</button></div>
        <button class="remove-line" type="button" data-action="remove">Remove</button>
      </div>`;
    }).join('');

    configureDeliveryOptions(cart);
    const savedZone = cart.attributes?.['Delivery area'];
    const savedNotes = cart.attributes?.['Suburb or notes'];
    if (zone && savedZone === 'Scheduled Brisbane run') zone.value = 'Over 50 km — request a quote';
    else if (zone && savedZone && [...zone.options].some(option => option.value === savedZone)) zone.value = savedZone;
    if (notes && savedNotes && document.activeElement !== notes) notes.value = savedNotes;
    if (zone) {
      for (const option of zone.options) option.disabled = planterOnly(cart) && option.value !== 'Market pickup';
      if (planterOnly(cart)) zone.value = 'Market pickup';
    }
    updateCheckout();
  }

  async function getCart() {
    const response = await fetch(`${routes.cart || '/cart'}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  }

  function openCart() {
    if (!drawer || !scrim) return;
    getCart().catch(() => {});
    scrim.hidden = false;
    requestAnimationFrame(() => scrim.classList.add('visible'));
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
    document.querySelectorAll('.cart-trigger').forEach(button => button.setAttribute('aria-expanded', 'true'));
    setTimeout(() => document.querySelector('.cart-close')?.focus(), 120);
  }

  function closeCart() {
    if (!drawer || !scrim) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    scrim.classList.remove('visible');
    document.body.classList.remove('cart-open');
    document.querySelectorAll('.cart-trigger').forEach(button => button.setAttribute('aria-expanded', 'false'));
    setTimeout(() => { scrim.hidden = true; }, 260);
  }

  async function addVariant(id, quantity = 1, name = 'Item') {
    const response = await fetch(routes.cartAdd || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) || 1 }] })
    });
    if (!response.ok) throw new Error('Unable to add item');
    await getCart();
    showToast(`${name} added to your order`);
    openCart();
  }

  document.querySelectorAll('.js-add-to-cart').forEach(button => {
    button.addEventListener('click', async () => {
      const original = button.innerHTML;
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        await addVariant(button.dataset.variantId, 1, button.dataset.productName || 'Item');
        button.innerHTML = 'Added ✓';
      } catch (_) {
        button.textContent = 'Please try again';
      }
      setTimeout(() => { button.innerHTML = original; button.disabled = false; }, 1300);
    });
  });

  document.querySelectorAll('.js-product-form').forEach(form => {
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const data = new FormData(form);
      const button = form.querySelector('[type="submit"]');
      const original = button?.innerHTML;
      if (button) { button.disabled = true; button.textContent = 'Adding…'; }
      try {
        await addVariant(data.get('id'), data.get('quantity') || 1, document.querySelector('.shopify-product h1')?.textContent.trim() || 'Item');
      } catch (_) {
        if (button) button.textContent = 'Please try again';
      }
      setTimeout(() => { if (button) { button.innerHTML = original; button.disabled = false; } }, 1300);
    });

    const variant = form.querySelector('select[name="id"]');
    variant?.addEventListener('change', () => {
      const option = variant.options[variant.selectedIndex];
      const price = document.querySelector('[data-product-price]');
      if (price && option.dataset.price) price.textContent = money.format(Number(option.dataset.price) / 100);
    });
  });

  lines?.addEventListener('click', async event => {
    const button = event.target.closest('button[data-action]');
    if (!button || !cartState) return;
    const line = button.closest('.cart-line');
    const item = cartState.items.find(entry => entry.key === line?.dataset.lineKey);
    if (!item) return;
    let quantity = item.quantity;
    if (button.dataset.action === 'increase') quantity += 1;
    if (button.dataset.action === 'decrease') quantity = Math.max(0, quantity - 1);
    if (button.dataset.action === 'remove') quantity = 0;
    button.disabled = true;
    try {
      const response = await fetch(routes.cartChange || '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.key, quantity })
      });
      if (!response.ok) throw new Error('Unable to update cart');
      renderCart(await response.json());
    } catch (_) {
      button.disabled = false;
    }
  });

  async function saveCartAttributes() {
    if (!zone || !notes) return;
    try {
      const response = await fetch(routes.cartUpdate || '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Delivery area': zone.value, 'Suburb or notes': notes.value.trim() } })
      });
      if (response.ok) renderCart(await response.json());
    } catch (_) {}
  }

  zone?.addEventListener('change', () => {
    const deliveryMessage = document.querySelector('.delivery-message');
    updateCheckout();
    saveCartAttributes();
  });
  notes?.addEventListener('input', () => { clearTimeout(attributesTimer); attributesTimer = setTimeout(saveCartAttributes, 500); });
  async function beginOrderEnquiry(event) {
    event.preventDefault();
    const link = event.currentTarget;
    if (link.classList.contains('is-disabled')) return;
    const originalLabel = link.textContent;
    link.textContent = 'Preparing your enquiry…';
    link.setAttribute('aria-busy', 'true');
    try {
      // Save cart-page quantities before preparing the enquiry.
      const cartForm = link.closest('.cart-page-form');
      if (cartForm) {
        const updates = [...cartForm.querySelectorAll('input[name="updates[]"]')].map(input => Math.max(0, Number(input.value) || 0));
        const result = await fetch(routes.cartUpdate || '/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
        if (!result.ok) throw new Error('Unable to update quantities');
      }
      await saveCartAttributes();
      const cart = await getCart();
      if (!cart.item_count) { showToast('Add a bed or planter to your order first.'); return; }
      const pickup = planterOnly(cart) || zone?.value === 'Market pickup';
      const area = pickup ? 'Market pickup' : (zone?.value || cart.attributes?.['Delivery area'] || 'Address confirmation');
      const summary = [
        'Order enquiry — availability and arrangements to be confirmed',
        ...cart.items.map(item => `${item.quantity} × ${item.product_title}${item.variant_title && item.variant_title !== 'Default Title' ? ` — ${item.variant_title}` : ''}: ${money.format(item.final_line_price / 100)}`),
        `Product subtotal: ${money.format(cart.total_price / 100)} (delivery, if applicable, confirmed separately)`,
        `Requested arrangement: ${area}`,
        hasCafe(cart) ? 'Vintage Cow Café weekend, 7–8 November. Delivery radius is measured from 105 Mocatta Street, Goombungee. Up to 15 km $20; over 15–30 km $60; over 30 km quote.' : '',
        pickup ? 'Please confirm the pickup market and date.' : 'Please provide a delivery quote and confirm the delivery date before payment.',
        notes?.value.trim() ? `Notes: ${notes.value.trim()}` : '',
        'No payment has been made. Please send a payment link once confirmed.'
      ].filter(Boolean).join('\n');
      const destination = new URL(link.href, window.location.origin);
      destination.searchParams.set('topic', pickup ? 'market-pickup' : 'delivery');
      destination.searchParams.set('order', '1');
      // A URL fragment keeps the enquiry details on this device until the customer submits the form.
      destination.hash = new URLSearchParams({ enquiry: summary }).toString();
      window.location.assign(destination.href);
    } catch (_) {
      showToast('We couldn’t prepare your enquiry. Please try again, or contact us directly.');
    } finally {
      link.textContent = originalLabel;
      link.removeAttribute('aria-busy');
    }
  }
  document.querySelectorAll('.js-order-enquiry').forEach(link => link.addEventListener('click', beginOrderEnquiry));
  checkout?.addEventListener('click', async event => {
    if (hasCafe(cartState) && !cafeOnly(cartState)) { event.preventDefault(); showToast('Please order café beds separately from the regular range.'); return; }
    if (!canCheckout()) return beginOrderEnquiry(event);
    event.preventDefault();
    if (checkout.classList.contains('is-disabled')) return;
    checkout.textContent = 'Opening checkout…';
    checkout.setAttribute('aria-busy', 'true');
    try {
      await saveCartAttributes();
      const current = await getCart();
      if (!current.item_count || !canCheckout()) { updateCheckout(); return; }
      window.location.assign('/checkout');
    } catch (_) {
      showToast('Checkout could not open. Please try again.');
      updateCheckout();
    } finally { checkout.removeAttribute('aria-busy'); }
  });
  document.querySelectorAll('.cart-trigger').forEach(button => button.addEventListener('click', openCart));
  document.querySelector('.cart-close')?.addEventListener('click', closeCart);
  document.querySelector('.close-and-shop')?.addEventListener('click', closeCart);
  scrim?.addEventListener('click', closeCart);
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && drawer?.classList.contains('open')) closeCart(); });

  document.querySelectorAll('details').forEach(detail => {
    detail.addEventListener('toggle', () => {
      if (!detail.open) return;
      document.querySelectorAll('details').forEach(other => { if (other !== detail) other.open = false; });
    });
  });

  const revealElements = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    revealElements.forEach(element => observer.observe(element));
  } else {
    revealElements.forEach(element => element.classList.add('visible'));
  }

  if (!reduceMotion && window.matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('[data-tilt]').forEach(card => {
      card.addEventListener('pointermove', event => {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        card.style.transform = `perspective(1400px) rotateX(${y * -1.8}deg) rotateY(${x * 1.8}deg)`;
      });
      card.addEventListener('pointerleave', () => { card.style.transform = ''; });
    });

    const stage = document.querySelector('.hero-stage');
    stage?.addEventListener('pointermove', event => {
      const rect = stage.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width - 0.5;
      const y = (event.clientY - rect.top) / rect.height - 0.5;
      stage.querySelectorAll('[data-depth]').forEach(layer => {
        const depth = Number(layer.dataset.depth);
        layer.style.translate = `${x * depth * 5}px ${y * depth * 5}px`;
      });
    });
    stage?.addEventListener('pointerleave', () => stage.querySelectorAll('[data-depth]').forEach(layer => { layer.style.translate = ''; }));
  }

  const photoSwap = document.querySelector('.two-photo-swap');
  photoSwap?.addEventListener('click', () => photoSwap.classList.toggle('show-alt'));
  const premiumDeck = document.querySelector('.premium-deck');
  premiumDeck?.addEventListener('click', () => premiumDeck.classList.toggle('spread'));

  const topic = document.querySelector('#contact-topic');
  const requestedTopic = new URLSearchParams(window.location.search).get('topic');
  if (topic && requestedTopic && [...topic.options].some(option => option.value === requestedTopic)) topic.value = requestedTopic;

  const enquirySummary = new URLSearchParams(window.location.hash.slice(1)).get('enquiry');
  const contactMessage = document.querySelector('#contact-message');
  const isOrderEnquiry = new URLSearchParams(window.location.search).get('order') === '1';
  if (contactMessage && enquirySummary && (!contactMessage.value.trim() || contactMessage.dataset.orderPrefill === 'true')) contactMessage.value = enquirySummary;
  if (contactMessage && isOrderEnquiry) {
    const pickupEnquiry = requestedTopic === 'market-pickup';
    const contactHeading = document.querySelector('#contact-form h2');
    const contactSubmit = document.querySelector('#contact-form [type="submit"]');
    const locationLabel = document.querySelector('label[for="contact-location"]');
    const locationInput = document.querySelector('#contact-location');
    if (contactHeading) contactHeading.textContent = pickupEnquiry ? 'Arrange your market pickup.' : 'Confirm your delivery address.';
    if (contactSubmit) contactSubmit.textContent = pickupEnquiry ? 'Send pickup enquiry' : 'Send address for confirmation';
    if (locationLabel) locationLabel.textContent = pickupEnquiry ? 'Preferred market or pickup suburb' : 'Full delivery address, including suburb and postcode';
    if (locationInput) locationInput.autocomplete = pickupEnquiry ? 'off' : 'street-address';
  }

  getCart().catch(() => {});
})();
